/*
 * Copyright (C) 2019-2021 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Types of text elements.
 */
export enum TextElementType {
    PoiLabel,
    PathLabel,
    LineMarker
}
